<template>
  <div class="card" v-show="currentCardId == 'reason'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>志望動機を入力</h2>
        <p>{{ reasonLabel }}</p>
      </div>

      <div class="add-item">
        <el-button type="success" @click="exampleVisible = true"
          >例文から追加</el-button
        >
      </div>

      <div class="card-content">
        <NewRirekishoExampleSentenceDialog
          :value="exampleVisible"
          name="reason-dialog"
          :items="reasonExamples"
          :show-overwrite-warning="true"
          @input="exampleVisible = $event"
          @select="onSelectExample"
        />
        <el-input
          type="textarea"
          v-model="formatData.reason"
          v-proofread
          :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
        />
        <div class="attention-limit character" v-if="previewErrors.reason">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'

const reasonLabel =
  '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！'

const props = defineProps<{
  currentCardId?: string
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
  textareaMinRows: number
}>()

const formatData = useNewRirekishoFormatData()
const exampleVisible = ref(false)

const reasonExamples = computed(() => props.exampleSentences?.reason || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  formatData.reason = item.description.replace(/<br>/gi, '\n')
}
</script>
